import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.projects.reorder.title, 'Reorder projects'),
  preview: () => __(translations.projects.reorder.preview, 'Preview'),
  save: () => __(translations.projects.reorder.save, 'Save order'),
  cancel: () => __(translations.projects.reorder.cancel, 'Cancel'),
  unranked: () => __(translations.projects.reorder.unranked, 'Unranked'),
  filterByType: () => __(translations.projects.reorder.filterByType, 'Filter by type'),
  button: () => __(translations.projects.reorder.button, 'Reorder'),
};
